module.exports = __webpack_public_path__ + "static/media/CalendarEvent5.d8dbc54b.jpg";